<div style="transition: all 2s linear">
    <div class="d-sm-block d-flex loan-tenure-wrapper">
        <mat-radio-group class="loan-tenure" [(ngModel)]="loanTenure">
            <div class="col-sm-4 col-xs-12 col-12 p-0 pb-2" *ngFor="let tenureOption of loanTenureOptions">
                <mat-radio-button color="primary" [value]="tenureOption"
                    (change)="setCustomPortfolioPreference(tenureOption, $event)">
                    <span class="font-weight-normal text-wrap-balance">Less than {{ tenureOption }} months</span>
                </mat-radio-button>
            </div>
        </mat-radio-group>
    </div>
</div>